import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    { title: 'Código', active: true },
    { title: 'Nombre', active: true },
    { title: 'Sucursal', active: true },
];

class CutTransferModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            users: [],
        }
    }

    componentDidMount() {
        this.closeAction();
    }

    close = async () => {
        $('#cutTransferUsersModal').modal('hide');
    }

    closeAction = () => {
        $('#cutTransferUsersModal').on('hidden.bs.modal', function () {
        });
    };

    render() {
        const { users, selectUser } = this.props;

        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll" role="dialog" id="cutTransferUsersModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document" >
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">Usuario destino</h4>
                                <button type="button" className="close" onClick={this.close} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" >
                                <div className="contanier">
                                    <div className="row m-1 justify-content-around">
                                        <div className="col-12" style={{ width: '100%' }}>
                                            <DataTablesCreate data={users} headers={headers} view={"cutTransferUsersModal"} action={selectUser} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.close}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CutTransferModal;